export default {
  loginIn: "Đăng nhập",//登录按钮
  loginOut: "Thoát",
  currentAccount: "TK hiện tại",
  emptyMsg: "TK hiện tại chưa phát hiện có nhân vật, đổi TK khác thử nào",
  validMsg: "Nhân vật chơi gần đây:",
  goNewGame: "Bắt đầu game mới",
  reLogin: "Đăng nhập lại",
  loginDig: "Đăng nhập",//弹出框登录提示
  expirationTime: "Trong 30 ngày duy trì trạng thái đăng nhập",
  goto: "Đi",
  haveRoles: "Xem các n.vật đã có khác",
  gameDes: "Giới thiệu cho trò chơi",
  moreGame: "Nhiều trò chơi",
  // 邮箱登录
  forgetPas:"Quên mật khẩu?",
  changePas:"Đặt lại mật khẩu",
  passwordHolder:"Nhập mật khẩu của bạn",
  codeHolder:"Nhập mã xác nhận",
  getCode:"Mã xác nhận",
  newPasswordHolder:"Nhập mật khẩu mới",
  newPasswordHolder2:"Xác nhận mật khẩu mới",
  newPasswordError:"Mật khẩu không khớp.",
  codeLimit:"4-6 ký tự",
  passwordLimit:"4-20 ký tự",
  loginSuccess:"Đăng nhập thành công",
  codeSend:"Mã xác minh đã được gửi đến email của bạn",
  pasSendSuccess:"Đặt lại mật khẩu thành công",
  // 支付弹框
  pleaseConfirm: "Hãy xác nhận",
  payType: "Phương thức thanh toán",
  immediatePay: "Thanh toán ngay",
  choosePayType: "Hãy chọn phương thức thanh toán",
  // 导航部分
  recharge: "Trung Tâm Nạp Tiền",
  persion: "Trung Tâm Cá Nhân",
  myGame: "Game",
  myOrder: "Đơn hàng",
  customer: "CSKH",
  hotQuestion: "Câu hỏi hàng đầu",
  connectService: "Liên hệ CSKH",
  // 首页 footer
  address: "2013-2020",
  company: "YoFi Games",
  aboutOur: "Về chúng tôi",
  careOur: "Theo dõi chúng tôi",
  agreement: "Thỏa thuận người dùng",
  privacy: "Chính sách bảo mật",
  // 充值页面
  game: "Game",
  gameHolder: "Hãy chọn game",
  server: "Nhân vật",
  serverHolder: "Hãy chọn server",
  role: "Nhân vật",
  roleHolder: "Hãy chọn nhân vật",
  rechargeGear: "Mốc nạp",
  usuallyGoods: "Quà Ngày",
  limitGoods: "Quà Hạn Định",
  jfdh:"Đổi điểm",
  qiandao:"Kiểm tra túi quà đi.",
  searchGoods: "Quà Tìm Kiếm",
  purchase: "Mua",
  confirmAccount: "Hãy xác nhận tài khoản",
  payconfirmHolder: "Xác nhận có nạp tiền không",
  payContinue: "Thanh toán lại",
  payOver: "Đã hoàn thành thanh toán",
  goodsEmpty: "Hãy chọn VP cần mua",
  payTipMsg1: "Hãy hoàn thành thanh toán trên trang mới mở！",
  payTipMsg2: "Trước khi thanh toán xong đừng tắt cửa sổ nha",
  // 我的游戏
  roleName: "Tên nhân vật",
  roleId: "ID nhân vật",
  roleName: "Tên nhân vật",
  roleLeavel: "Cấp nhân vật",
  vipLeavel: "Cấp VIP",
  interestedGame: "Game có thể bạn thích",
  playGame: "Bắt đầu game",
  goRecharge: "Đến nạp tiền",
  // 我的订单
  dateTimeRange: "Thời gian",
  startTime: "Bắt đầu",
  endTime: "Kết thúc",
  to: "Đến",
  nickName: "Nick",
  goodsName: "Quà/Xu Game",
  price: "Giá",
  orderId: "Số đơn hàng",
  rechargeTime: "Thời gian nạp",
  orderState: "Trạng thái đơn hàng",
  paySuccess: "Thanh toán thành công",
  orderClose: "Đã đóng",
  doPay: "Thanh toán",
  doClose: "Đóng",
  noData: "Không có dữ liệu",
  search: "Tra",
  confirm: "OK",
  colseConfirm: "Xác định đóng đơn hàng này chứ?",
  colseSuccess: "Đóng thành công",
  tip: "Nhắc",
  // 联系客服
  feedBack: "Phản hồi vấn đề nạp tiền",
  questionTime: "Thời gian xảy ra",
  questionTimeHolder: "Hãy chọn thời gian xảy ra",
  email: "Email",
  emailHolder: "Hãy chọn Email",
  describe: "Mô tả vấn đề",
  describeHolder: "Hãy điền mô tả",
  screenshot: "Ảnh liên quan",
  cancel: "Hủy",
  submit: "Gửi",
  submitSuccess: "Gửi thành công",
  emailNotEmpty: "Email không được để trống",
  emailFormat: "Hãy nhập định dạng Email chính xác",
  desEmpty: "Mô tả vấn đề không được để trống",
  desMore: "Mô tả vấn đề không được quá 255 ký tự",
  imgTypeError: "Lỗi định dạng file ảnh!",
  imgSizeError: "Size ảnh không được lớn hơn 3MB!",
  // 公司介绍页面
  companyProfile: "Giới thiệu công ty",
  companyDes: "Yofi Network thành lập vào năm 2013, trụ sở chính ở Thượng Hải, thành viên thành lập đến từ các công ty nổi tiếng như Shanda, Guokr, Hoodinn, là 1 nhà phát triển game toàn diện chuyên nghiên cứu và vận hành game di động. Lần lượt thiết lập mối quan hệ hợp tác 2 bên cùng có lợi với 3975, SPyouxi.",
  developmentHis: "Quá trình phát triển",
  developmentDes1: "Yofi là 1 công ty game sôi động tràn đầy sức sống. Từ khi thành lập vào tháng 8 năm 2013 đến nay, đội ngũ công ty không ngừng phát triển mở rộng, từ cấu trúc thành viên đơn lẻ đến cùng lúc ra mắt nhiều dự án, từng bước tích lũy kinh nghiệm phát triển trên lĩnh vực game di động, sản phẩm công ty bao phủ nhiều thể loại game, dốc sức tạo ra trải nghiệm game hoàn hảo chưa từng có trước đây.",
  developmentDes2: "Dựa vào thực lực tự nghiên cứu của mình, Yofi nghiên cứu sâu vào phát triển game di động, đồng thời không ngừng tìm tòi và mở rộng trên lĩnh vực phát hành và vận hành game, nâng cao thương hiệu và tầm ảnh hưởng của mình, tích cực ra mắt các game xịn, tạo ra và duy trì hệ thống sinh thái game lành mạnh tốt đẹp.",
  developmentDes3: "Trong tương lai, Yofi sẽ tiếp tục tìm tòi, ra mắt nhiều sản phẩm nổi bật hơn.",
  Telephone: "Điện thoại",
  Fax: "Fax",
  country: "Quốc gia",
  countryHolder: "Hãy chọn quốc gia",
  countryList: [
    { countryId: 360, countryName: 'Indonesia', currency: "IDR" },
    // { countryId: 608, countryName: 'Philippines', currency: "PHP" },
    { countryId: 458, countryName: 'Malaysia', currency: "MYR" },
    { countryId: 702, countryName: 'Singapore', currency: "SGD" },
    // { countryId: 764, countryName: 'Thái lan', currency: "THB" },
    // { countryId: 104, countryName: 'Myanmar', currency: "MMK" },
    // { countryId: 418, countryName: 'Lào', currency: "LAK" },
    // { countryId: 116, countryName: 'Campuchia', currency: "USD" },
    // { countryId: 626, countryName: 'Đông Timor', currency: "USD" }
  ]
}


// WEBPACK FOOTER //
// ./src/common/lang/vi-VN.js